import { useTranslation } from "react-i18next";
import { removeCryptoWallet } from "../../store/actions/cryptoWalletsAction";
import { useDispatch } from "react-redux";
import Popup from "../common/Popup";
import { useState } from "react";
import Confirm from "../common/Confirm";
import { fetchDeleteWallet } from "../../pages/FetchDeleteWallet";

function CryptoWallet({ wallet, num }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [error, setError] = useState(false);
  const deleteWallet = () => {
    fetchDeleteWallet(wallet.key, "crypto").then((data) => {
      if (data.susscess) {
        dispatch(removeCryptoWallet(data.key));
      } else {
        setError(true);
      }
    });
    
  };

  const [isPopupOpenConfirmCrypto, setIsPopupOpenConfirmCrypto] =
    useState(false);
  const closePopupConfirmCrypto = () => {
    setIsPopupOpenConfirmCrypto(false);
  };

  const openPopupConfirmCrypto = () => { 
    setIsPopupOpenConfirmCrypto(true);
  }

  function convertTRCIdentifiers(input) {
    return input.replace(/trc(\d+)/gi, (match, number) => `(TRC-${number})`);
  }

  return (
    <div className="wallet__item">
      <Popup
        isOpen={isPopupOpenConfirmCrypto}
        onClose={closePopupConfirmCrypto}
      >
        <Confirm
          confirm={deleteWallet}
          closePopup={closePopupConfirmCrypto}
          heading={t("Remove Crypto Wallet")}
          error={t("This wallet cannot be removed")}
          isError={error}
          description={t("Are you sure you want to remove this wallet?")}
          yesText={t("Yes, delete it")}
          noText={t("Cancel")}
        />
      </Popup>
      <div className="grid-row-span-2 number-wallet">#{num + 1}</div>
      <h4>{wallet.name}</h4>
      <p className="grid-column-2 grid-row-2">
        {wallet.curr.toUpperCase()} {`${convertTRCIdentifiers(wallet.type.toUpperCase())}`} {t("crypto wallet ending in")}{" "}
        {wallet.num.slice(-4)}
      </p>
      <div onClick={openPopupConfirmCrypto} className="grid-row-span-2 delete-wallet">
        <i className="ri-close-large-line"></i>
      </div>
    </div>
  );
}

export default CryptoWallet;
